import { Loader } from 'component-library';
import { useEffect, useState } from 'react';

import { Plot } from '@/api/rest/resources/types/plot';
import { CheckboxCell } from '@/pages/shared/projects/pages/project/pages/sustainableProduction/pages/plots/components/Cells';

import { useEnabledPlotsForOrganization } from '../../hooks/usePlotsForOrganization';

export const SelectAllPlotsCheckbox = ({
  totalPlotCount,
  currentSelectedPlotIds,
  updateSelectedPlotIds,
  resolvedPlotFilters,
  organizationId,
  setAllPlots,
}: {
  totalPlotCount: number;
  currentSelectedPlotIds: string[];
  updateSelectedPlotIds: (ids: string[]) => void;
  resolvedPlotFilters: Record<string, unknown> | undefined;
  organizationId: string;
  setAllPlots: (plots: Plot[]) => void;
}) => {
  const [fetchAllEnabled, setFetchAllEnabled] = useState(false);
  const allPlotsQuery = useEnabledPlotsForOrganization(
    organizationId,
    resolvedPlotFilters,
    undefined,
    undefined,
    undefined,
    undefined,
    fetchAllEnabled,
  );

  useEffect(() => {
    if (!fetchAllEnabled || allPlotsQuery.isLoading) {
      return;
    }

    if (allPlotsQuery.data) {
      const allPlots = allPlotsQuery.data.results;
      const allIds = allPlots.map((plot) => plot.id);

      updateSelectedPlotIds(allIds);
      setAllPlots(allPlots);
    }
  }, [fetchAllEnabled, updateSelectedPlotIds, setAllPlots, allPlotsQuery.data, allPlotsQuery.isLoading]);

  const selectAllRows = () => {
    if (!fetchAllEnabled) {
      setFetchAllEnabled(true);
    }

    if (currentSelectedPlotIds.length === totalPlotCount && totalPlotCount > 0) {
      updateSelectedPlotIds([]);
    }
  };

  if (allPlotsQuery.isLoading) {
    return <Loader className='min-h-[10px]' />;
  }

  return (
    <CheckboxCell
      {...{
        checked: totalPlotCount > 0 && currentSelectedPlotIds.length === totalPlotCount,
        indeterminate: currentSelectedPlotIds.length > 0 && currentSelectedPlotIds.length < totalPlotCount,
        onChange: () => selectAllRows(),
      }}
    />
  );
};
